import { z } from "zod";
import { tenantStatusSchema } from "./enums.js";
/**
 * A tenant slug is the studio's subdomain, so it has to survive a DNS label: lowercase
 * alphanumerics separated by single hyphens, no leading or trailing hyphen. The database
 * enforces the same shape with a CHECK constraint — this schema is the redundant safety net,
 * not the guarantee.
 */
export const tenantSlugSchema = z
    .string()
    .min(2, "El identificador tiene que tener al menos 2 caracteres.")
    .max(63, "El identificador no puede superar los 63 caracteres.")
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, "El identificador solo admite minúsculas, números y guiones simples.");
/** `#RRGGBB`. Applied as a CSS variable at bootstrap; never hardcoded in a component. */
export const hexColorSchema = z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, "El color tiene que ser un hexadecimal de 6 dígitos, como #1a4d8f.");
/**
 * The contact block printed in the header and footer of every generated document.
 * Article VII fixes the required set: nothing here is optional for a studio that hands
 * documents to its clients, but a studio being provisioned may not have filled it in yet.
 */
export const brandingContactSchema = z.object({
    address: z.string().max(200).optional(),
    phone: z.string().max(50).optional(),
    email: z.email("El correo de contacto no es válido.").optional(),
});
export const brandingSchema = z.object({
    displayName: z.string().min(1, "El nombre del estudio es obligatorio.").max(120),
    logoUrl: z.url().nullable(),
    primaryColor: hexColorSchema,
    contact: brandingContactSchema,
});
/** Body of `PATCH /api/tenant/branding`. Every field optional; at least one required. */
export const brandingUpdateSchema = brandingSchema
    .omit({ logoUrl: true })
    .extend({ logoFileId: z.uuid().nullable() })
    .partial()
    .refine((value) => Object.keys(value).length > 0, {
    message: "No hay ningún cambio para aplicar.",
});
/**
 * What `GET /api/tenant/branding` returns. Readable before login so the login screen is already
 * the studio's, and deliberately free of anything a logged-out visitor should not see: no
 * contract dates, no user counts, no internal identifiers beyond the slug already in the URL.
 */
export const publicTenantSchema = z.object({
    slug: tenantSlugSchema,
    status: tenantStatusSchema,
    branding: brandingSchema,
});
//# sourceMappingURL=tenant.js.map